import { render, staticRenderFns } from "./bargainGoods.vue?vue&type=template&id=78bf0b4e&scoped=true&"
import script from "./bargainGoods.vue?vue&type=script&lang=js&"
export * from "./bargainGoods.vue?vue&type=script&lang=js&"
import style0 from "./bargainGoods.vue?vue&type=style&index=0&id=78bf0b4e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf0b4e",
  null
  
)

export default component.exports